// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__i2Y3d","footer":"ChangeClinic_footer__3n2Uf"};